export default [
  {
    name: 'checkIn',//优先值机
    path: '/checkIn',
    component: resolve => require(['Views/AirService/checkIn/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'checkInEdit',//优先值机 订单填写
    path: '/checkIn/edit',
    component: resolve => require(['Views/AirService/checkIn/edit.vue'], resolve),
    meta: {
      include: [],
      index: 3
    }
  },
  {
    name: 'checkIn',//优先值机 订单详情
    path: '/checkIn/order',
    component: resolve => require(['Views/AirService/checkIn/order.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
    
  {
    name: 'guestPass',//要客通
    path: '/guestPass',
    component: resolve => require(['Views/AirService/guestPass/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'guestPassConfirm',//要客通  确认订单
    path: '/guestPass/confirm',
    component: resolve => require(['Views/AirService/guestPass/confirm.vue'], resolve),
    meta: {
      include: [],
      index: 3
    }
  },
  {
    name: 'guestPassEdit',//要客通  服务信息填写
    path: '/guestPass/edit',
    component: resolve => require(['Views/AirService/guestPass/edit.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
  {
    name: 'guestPassOrder',//要客通  订单详情
    path: '/guestPass/order',
    component: resolve => require(['Views/AirService/guestPass/order.vue'], resolve),
    meta: {
      include: [],
      index: 5
    }
  },
    
  {
    name: 'fastCheck',//快速安检
    path: '/fastCheck',
    component: resolve => require(['Views/AirService/fastCheck/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'fastCheckEdit',//快速安检 确认订单
    path: '/fastCheck/edit',
    component: resolve => require(['Views/AirService/fastCheck/edit.vue'], resolve),
    meta: {
      include: [],
      index: 3
    }
  },
  {
    name: 'fastCheckOrder',//快速安检 订单详情
    path: '/fastCheck/order',
    component: resolve => require(['Views/AirService/fastCheck/order.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
    
  {
    name: 'restRoom',//休息室
    path: '/restRoom',
    component: resolve => require(['Views/AirService/restRoom/index.vue'], resolve),
    meta: {
      include: [],
      index: 2
    }
  },
  {
    name: 'restRoomConfirm',//休息室 确认购买
    path: '/restRoom/confirm',
    component: resolve => require(['Views/AirService/restRoom/confirm.vue'], resolve),
    meta: {
      include: [],
      index: 3
    }
  },
  {
    name: 'restRoomEdit',//休息室 下单
    path: '/restRoom/edit',
    component: resolve => require(['Views/AirService/restRoom/edit.vue'], resolve),
    meta: {
      include: [],
      index: 4
    }
  },
  {
    name: 'restRoomOrder',//休息室 订单详情
    path: '/restRoom/order',
    component: resolve => require(['Views/AirService/restRoom/order.vue'], resolve),
    meta: {
      include: [],
      index: 5
    }
  }
]
